import { useState } from "react";
import { X } from "lucide-react";
import { PackGrid } from "./PackGrid";
import { useNavigate } from "react-router-dom";

export { PACKS } from "./PackGrid";

export const CreditsSheet = ({ onClose, title = "Top up credits", subtitle }) => {
  const navigate = useNavigate();
  const [open] = useState(true);
  if (!open) return null;
  return (
    <div className="sheet-backdrop" onClick={onClose} data-testid="credits-sheet-backdrop">
      <div className="sheet" onClick={(e) => e.stopPropagation()} data-testid="credits-sheet">
        <div className="flex items-center justify-between">
          <p className="eyebrow">Credits</p>
          <button type="button" className="icon-btn" onClick={onClose} data-testid="credits-sheet-close" aria-label="Close"><X size={16} /></button>
        </div>
        <h2 className="card-title" data-testid="credits-sheet-title">{title}</h2>
        {subtitle && <p className="text-sm text-muted mt-1">{subtitle}</p>}
        <div className="mt-4"><PackGrid /></div>
        <button type="button" className="btn-secondary mt-4" onClick={() => { onClose(); navigate("/app/billing"); }} data-testid="credits-sheet-billing-link">Plan, history & subscription</button>
      </div>
    </div>
  );
};
